module.exports = __webpack_public_path__ + "static/media/phone3.b7c4e8f7.png";